module.exports = __webpack_public_path__ + "e1b5c8ae7c673393200bf5bbe8533627.svg";